import { render, staticRenderFns } from "./OrderDeviceTab.vue?vue&type=template&id=6afeada1&scoped=true"
import script from "./OrderDeviceTab.vue?vue&type=script&lang=js"
export * from "./OrderDeviceTab.vue?vue&type=script&lang=js"
import style0 from "./OrderDeviceTab.vue?vue&type=style&index=0&id=6afeada1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afeada1",
  null
  
)

export default component.exports